import React, { useState } from "react";
import styles from "../UserForm/UserForm.module.css";
import CreateUserL from "../UserForm/UserForm";
import CreateCompanyL from "../CompanyForm/CompanyForm";
import HeaderLogoIcon from "../../components/headerLogoIcons/headerLogoIcons";
import FooterHomePage from "../../components/footerHomePage/footerHomePage";

const FormL = () => {
  const [typePerson, setTypePerson] = useState({
    typeForm: "Persona Humana",
  });

  return (
    <>
      <HeaderLogoIcon />
      <div className={styles.container2}>
        <div className={styles.boxinputsdefinded}>
          <label className={styles.inputLabel3}>
            Tipo de usuario:
            <select
              className={styles.inputField}
              name="documentType"
              value={typePerson.typeForm || ""}
              onChange={(e) =>
                setTypePerson({
                  ...typePerson,
                  typeForm: e.target.value,
                })
              }
            >
              <option value="Persona Humana">Persona Humana</option>
              <option value="Persona Jurídica">Persona Jurídica</option>
              <option value="Otros">Otros</option>
            </select>
          </label>
        </div>
      </div>
      {typePerson.typeForm === "Persona Humana" ? (
        <CreateUserL />
      ) : typePerson.typeForm === "Otros" ? (
        <CreateCompanyL />
      ) : (
        <CreateCompanyL />
      )}
      <FooterHomePage />
    </>
  );
};
export default FormL;
